<template>
  <div class="discovery-root">
    <search-results
      :initSearch="this.query"
      :display="this.display"
      :showSearchbar="this.showSearchbar"
      :showHeader="this.showHeader"
      :showPager="this.showPager"
      ref="searchResults"
    ></search-results>
  </div>
</template>

<script>
/**
 * Example use:
 *
 * Discovery.vueLoader('BibSearch', el, {
 *   ui: false,
 *   display: 'masonry',
 *   query: {
 *     terms: `BRS=${el.dataset.recordSetId}`,
 *     num: 100,
 *     page: 0,
 *     sort: 'MP/sort.descending',
 *   },
 * })
 */
import SearchResults from '@/components/views/SearchResults.vue';

export default {
  name: 'BibSearch',
  data() {
    return {
      query: this.$root.params.query,
      display: this.$root.params.display ?? 'masonry',
      showSearchbar: this.$root.params.showSearchbar ?? true,
      showHeader: this.$root.params.showHeader ?? true,
      showPager: this.$root.params.showPager ?? true,
      coverSize: this.$root.params.coverSize ?? 'medium',
    };
  },
  components: {
    SearchResults,
  },
};

</script>

<style lang="less">
@import '~@/css/global';

</style>
